import { Injectable, signal } from '@angular/core';
import { AppSettings, defaults } from '../../app/app.config';

@Injectable({
    providedIn: 'root',
})
export class CoreService {
    private optionsSignal = signal<AppSettings>(this.loadOptions());

    /**
     * Carga las opciones iniciales.
     * Prioriza localStorage para mantener el estado (colapsado/abierto) tras recargar la página.
     */
    private loadOptions(): AppSettings {
        const saved = localStorage.getItem('app-settings');
        if (saved) {
            try {
                return { ...defaults, ...JSON.parse(saved) };
            } catch (e) {
                return defaults;
            }
        }
        return defaults;
    }

    getOptions() {
        return this.optionsSignal();
    }

    setOptions(options: Partial<AppSettings>) {
        this.optionsSignal.update((current) => {
            const next = { ...current, ...options };
            localStorage.setItem('app-settings', JSON.stringify(next));
            return next;
        });
    }
}
